const quickHelpLinks = {
  en: {
    trackAndTrace: 'https://www.unisportstore.com/track-and-trace/',
    return: 'https://www.unisportstore.com/faq/return/howtoreturn/'
  },
  sv: {
    trackAndTrace: 'https://www.unisportstore.se/track-and-trace/',
    return: 'https://www.unisportstore.se/retur/'
  },
  da: {
    trackAndTrace: 'https://www.unisport.dk/track-and-trace/',
    return: 'https://www.unisport.dk/retur/'
  },
  de: {
    trackAndTrace: 'https://www.unisportstore.de/track-and-trace/',
    return: 'https://www.unisportstore.de/retoure/'
  },
  at: {
    trackAndTrace: 'https://www.unisportstore.at/track-and-trace/',
    return: 'https://www.unisportstore.at/retoure/'
  },
  fr: {
    trackAndTrace: 'https://www.unisportstore.fr/track-and-trace/',
    return:
      'https://www.unisportstore.fr/faq/retours/comment-retourner-un-article/'
  },
  fi: {
    trackAndTrace: 'https://www.unisportstore.fi/track-and-trace/',
    return:
      'https://www.unisportstore.fi/faq/palautus-reklamaatio/miten-ja-mista-palautan-tuotteen/'
  },
  nl: {
    trackAndTrace: 'https://www.unisportstore.nl/track-and-trace/',
    return:
      'https://www.unisportstore.nl/faq/annuleren-retour/hoe-kan-ik-iets-retourneren/'
  },
  no: {
    trackAndTrace: 'https://www.unisportstore.no/track-and-trace/',
    return:
      'https://www.unisportstore.no/faq/retur-og-reklamasjon/retur-av-vare/'
  },
  pl: {
    trackAndTrace: 'https://www.unisport.pl/track-and-trace/',
    return: 'https://www.unisport.pl/faq/zwrot-zamowienia/zwrocic-zamowienie/'
  },
  it: {
    trackAndTrace: 'https://www.unisportstore.it/track-and-trace/',
    return:
      'https://www.unisportstore.it/faq/resi-e-rimborsi/come-funziona-il-reso/'
  }
};

export default quickHelpLinks;
